import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Row,
  Col,
  Table,
  Dropdown,
  Button,
  Divider,
  Modal,
  DatePicker,
  MenuProps,
  Image,
  Radio,
  Select,
} from "antd";
// import type { MenuProps } from "antd";
import {
  MoreOutlined,
  EditOutlined,
  DeleteOutlined,
  PrinterOutlined,
  ReloadOutlined,
  FolderOpenOutlined,
  DollarOutlined,
  FilterOutlined,
  CheckOutlined,
  AlertOutlined,
  ContainerOutlined,
  ContainerFilled,
  ControlFilled,
} from "@ant-design/icons";
import {
  getSalesService,
  getBuyersService,
  getMaterialService,
  getMetalsService,
  postInvoiceService,
  getSalePDF,
  deleteSaleService,
} from "./SalesPageService";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import _ from "lodash";
import Loader from "../../components/Loader/Loader";
import "./SalesPage.css";
import { removeTokenFromCookies } from "../../utils/cookies";
import Copyright from "../../components/Copyright/Copyright";
import printJS from "print-js";
import Cookies from "universal-cookie";
import moment from "moment";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;
const { Content } = Layout;

export interface SalesPageProps {}

const SalesPage = (props: SalesPageProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [salesList, setSalesList] = useState([]) as any;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [buyers, setBuyers] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [saleToDelete, setSaleToDelete] = useState({}) as any;
  const [loading, setLoading] = useState(true);
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const [printSaleData, setPrintSaleData] = useState(null) as any;
  const [saleDetailsTableData, setSaleDetailsTableData] = useState([]) as any;
  const [metals, setMetals] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [buyersSelectedOptions, setBuyersSelectedOptions] = useState("");
  const [dateRangeFilter, setDateRangeFilter] = useState([null, null]) as any;
  const [dateRangeValue, setDateRangeValue] = useState([null, null]) as any;
  const [buyersOptions, setBuyersOptions] = useState([]) as any;
  const [isFilteredData, setIsFilteredData] = useState(false);
  const cookies = new Cookies();
  let navigate = useNavigate();
  const currOffice = cookies.get("CURR_OFFICE");
  const saleColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center",
      width: "5%",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Date",
      key: "date",
      align: "center",
      // width: "7.5%",
      render: (record: any) => new Date(record.createdTimestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Time",
      key: "time",
      align: "center",
      // width: "7.5%",
      render: (record: any) =>
        new Date(record.createdTimestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    {
      title: "Buyer",
      key: "buyer",
      // width: "20%",
      render: (record: any) => getBuyerDisplayName(record.buyerID),
    },
    {
      title: "Total Net Weight (kg)",
      key: "totalNetWeight",
      align: "center",
      render: (record: any) =>
        record.totalNetWeight ? (
          <strong style={{ marginRight: "10px" }}>{Number(record.totalNetWeight).toFixed(1)}</strong>
        ) : (
          ""
        ),
    },
    {
      title: "Materials Info",
      key: "materials",
      // width: "10%",
      align: "center",
      render: (record: any) => {
        return record.totalNumMaterials
          ? `${record.totalNumMaterials} materials (${record.materialIDList.length} weights)`
          : `${record.materialIDList.length} weights`;
      },
    },
    {
      title: "Transaction Type",
      key: "transactionType",
      align: "center",
      render: (record: any) => {
        return record.smallTransaction ? (
          "Small"
        ) : (
          <>
            <ContainerFilled style={{ marginRight: "5px", color: "#283555" }} />
            Invoice
          </>
        );
      },
    },
    Table.EXPAND_COLUMN,
    {
      title: "Sale Completed",
      dataIndex: "completed",
      key: "completed",
      align: "center",
      // width: "7.5%",
      render: (record: any) =>
        record ? (
          <>
            <CheckOutlined style={{ color: "green", marginRight: "5px" }} /> Yes
          </>
        ) : (
          <>
            <AlertOutlined style={{ color: "orange", marginRight: "5px" }} />
            No
          </>
        ),
    },
    {
      title: "Invoice Issued",
      dataIndex: "invoiceIssued",
      key: "invoiceIssued",
      align: "center",
      // width: "7.5%",
      render: (record: any) => (record ? "Yes" : "No"),
    },
    {
      title: "Generate Invoice",
      key: "generateInvoice",
      align: "center",
      // width: "7.5%",
      render: (record: any) =>
        record.completed && !record.invoiceIssued ? (
          <Button type="primary" size="small" onClick={() => generateInvoice(record.saleID, record.buyerID)}>
            Generate Invoice
          </Button>
        ) : null,
    },
    // {
    //   title: "Print Sale",
    //   key: "printSale",
    //   align: "center",
    //   width: "10%",
    //   render: (record: any) =>
    //     record.completed ? (
    //       <Button type="primary" size="small" onClick={() => printSale(record)} icon={<PrinterOutlined />}>
    //         Print Sale
    //       </Button>
    //     ) : null,
    // },
    {
      title: "Options",
      key: "options",
      align: "center",
      width: "7.5%",
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        if (record.completed) items.push({ key: "print", label: "Print Sale", icon: <PrinterOutlined /> });
        record.completed && isTimestampMoreThan2Hours(record.createdTimestamp)
          ? items.push({ key: "edit", label: "View Sale", icon: <FolderOpenOutlined /> })
          : items.push({ key: "edit", label: "Edit Sale", icon: <EditOutlined /> });
        if (record.completed && record.invoiceIssued)
          items.push({ key: "invoice", label: "View Invoice", icon: <DollarOutlined /> });
        if (userRole === "admin")
          items.push({ key: "delete", label: "Delete Sale", icon: <DeleteOutlined />, style: { color: "red" } });

        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") editSale(record);
                else if (key === "delete") openDeleteSaleModal(record);
                else if (key === "print") printSale(record);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const saleDetailsColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Images",
      key: "index",
      render: (record: any) => (
        <>
          <Image
            height={50}
            width={50}
            src={record.scaleImageURL || record.imageURL}
            wrapperStyle={{ marginRight: "10px" }}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{record.displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                  <h3 style={{ color: "#000000" }}>Net Weight: {Number(record.netWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
          <Image
            height={50}
            width={50}
            src={record.materialImageURL}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{record.displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                  <h3 style={{ color: "#000000" }}>Net Weight: {Number(record.netWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
        </>
      ),
      align: "center" as const,
    },
    {
      title: "Material Name",
      dataIndex: "displayName",
      align: "center" as const,
      render: (name: string) => <strong>{name}</strong>,
    },
    {
      title: "Raw Weight (kg)",
      key: "rawWeight",
      // dateIndex: "rawWeight",
      align: "center" as const,
      render: (record: any) => {
        return record ? Number(record.rawWeight).toFixed(1) : null;
      },
    },
    {
      title: "Waste Weight (kg)",
      key: "wasteWeight",
      dateIndex: "wasteWeight",
      align: "center" as const,
      render: (record: any) => {
        if (record === undefined) return;
        let wasteInfo = "(";
        if (record.smallBag > 0) {
          if (record.bigBag > 0) wasteInfo += `${record.smallBag} small, `;
          else wasteInfo += `${record.smallBag} small`;
        }
        if (record.bigBag > 0) {
          if (record.jumboBag > 0) wasteInfo += `${record.bigBag} big, `;
          else wasteInfo += `${record.bigBag} big`;
        }
        if (record.jumboBag > 0) {
          wasteInfo += `${record.jumboBag} jumbo`;
        }
        wasteInfo += ")";
        return (
          <>
            <Row justify="center"> - {Number(record.wasteWeight).toFixed(1)}</Row>
            {(record.smallBag > 0 || record.bigBag > 0 || record.jumboBag > 0) && (
              <Row justify="center" style={{ fontSize: "12px" }}>
                {wasteInfo}
              </Row>
            )}
            {record.other && (
              <Row justify="center" style={{ fontSize: "12px" }}>
                ( Other: {record.other})
              </Row>
            )}
          </>
        );
      },
    },
    {
      title: "Net Weight (kg)",
      key: "netWeight",
      dateIndex: "netWeight",
      align: "center" as const,
      render: (record: any) => {
        if (record === undefined) return;
        return <strong>{Number(record.netWeight).toFixed(1)}</strong>;
      },
    },
    {
      title: "Manual Entry",
      dataIndex: "manualEntry",
      key: "completed",
      align: "center" as const,
      render: (record: any) =>
        record ? (
          <>
            <ControlFilled style={{ fontSize: "20px", color: "orange", marginRight: "5px" }} />
            Yes
          </>
        ) : (
          <>
            <ControlFilled style={{ fontSize: "20px", color: "green", marginRight: "5px" }} />
            No
          </>
        ),
    },
  ];

  useEffect(() => {
    navToSelectOffice();
    getBuyers();
    getMetals();
  }, []);

  useEffect(() => {
    getSales(currentPage, buyersSelectedOptions, dateRangeFilter);
  }, [currentPage]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const getSales = async (pageNumber: Number, buyersFilter: String, dateRangeFilter: String[]) => {
    try {
      setLoading(true);
      const filters = {
        buyers: buyersFilter,
        startDate: dateRangeFilter[0] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[0],
        endDate: dateRangeFilter[1] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[1],
      };
      const res = await getSalesService(currOffice, String(pageNumber), filters);
      setTotalPages(res.data.totalPages);
      setTotalSales(res.data.totalSales);
      const updatedSales = [...res.data.sales];
      for (let sale of updatedSales) {
        sale.key = sale.saleID;
      }
      setSalesList(updatedSales);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getSales error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMaterial = async (materialID: string) => {
    try {
      const res = await getMaterialService(materialID);
      return res;
    } catch (e: any) {
      console.error("getMaterial error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getBuyers = async () => {
    try {
      setLoading(true);
      const res = await getBuyersService();
      const buyersData = currOffice === "pg" ? res.data.pgBuyers : currOffice === "bw" ? res.data.bwBuyers : [];
      setBuyers(buyersData);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getBuyers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getBuyersFilterOptions = () => {
    const options: any = [];
    buyers.forEach((buyer: any) => {
      options.push({
        value: buyer.buyerID,
        label:
          buyer.companyName !== "" && buyer.companyName !== undefined
            ? `${buyer.companyName} ( ${buyer.name} )`
            : `${buyer.name}`,
      });
    });
    setBuyersOptions(options);
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setMetals(res.data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getBuyerDisplayName = (buyerID: string) => {
    const buyerInfo = buyers.find((buyer: any) => buyer.buyerID === buyerID);
    let buyerDisplayInfo = "";
    if (buyerInfo !== undefined && buyerInfo["companyName"] !== "" && buyerInfo["name"] !== "") {
      buyerDisplayInfo = buyerInfo["companyName"] + " (" + buyerInfo["name"] + ")";
    } else if (buyerInfo !== undefined && buyerInfo["companyName"] !== "") {
      buyerDisplayInfo = buyerInfo["companyName"];
    } else if (buyerInfo !== undefined && buyerInfo["name"] !== "") {
      buyerDisplayInfo = buyerInfo["name"];
    }
    return buyerDisplayInfo;
  };

  const generateInvoice = async (saleID: string, buyerID: string) => {
    try {
      setLoading(true);
      const currSale = salesList.find((sale: any) => sale.saleID === saleID);
      const payload = {
        saleCreatedTimestamp: currSale.createdTimestamp,
        smallTransaction: currSale.smallTransaction,
        saleID: saleID,
        buyerID: buyerID,
        totalNetWeight: currSale.totalNetWeight,
        totalNumMaterials: currSale.totalNumMaterials,
        office: currSale.office,
      };
      const res = await postInvoiceService(payload);
      setLoading(false);
      navigate(`/invoice/${res.data.invoiceID}`);
    } catch (e: any) {
      setLoading(false);
      console.error("generateInvoice error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const formatSaleBuyerFileName = (buyerID: string, saleID: string) => {
    const buyerInfo: any = buyers.find((buyer: any) => buyer.buyerID === buyerID);
    const buyerName = buyerInfo.companyName ? buyerInfo.companyName : buyerInfo.name;
    return `sale_${buyerName}_${saleID}.pdf`.replaceAll(" ", "_");
  };

  const printSale = async (saleDetails: any) => {
    try {
      setLoading(true);
      const fileName = formatSaleBuyerFileName(saleDetails.buyerID, saleDetails.saleID);
      const res = await getSalePDF(fileName);
      setPrintSaleData(res.data);
      setIsPDFModalOpen(true);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("printSale error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const closePDFModal = () => {
    setIsPDFModalOpen(false);
  };

  const isTimestampMoreThan2Hours = (timestamp: any) => {
    const createdMilliseconds = new Date(timestamp).getTime();
    const currentTimeMilliseconds = new Date().getTime();
    return currentTimeMilliseconds - createdMilliseconds > 7776000000 ? true : false;
  };

  const getSaleExpandedDetails = async (saleInfo: any) => {
    try {
      setLoading(true);
      const currSale = salesList.find((sale: any) => sale.saleID === saleInfo.saleID);
      const currMaterials: any[] = [];
      for (let materialID of currSale.materialIDList) {
        const resMaterial: any = await getMaterial(materialID);
        const materialData = resMaterial.data;
        const currMetal: any = metals.find((metal: any) => metal.metalID === materialData.metalID);
        materialData.displayName = currMetal.displayName;
        materialData.key = materialData.materialID;
        currMaterials.push(materialData);
      }
      const newSaleDetails = [...saleDetailsTableData];
      const newSaleDetailsObject = {
        saleID: saleInfo.saleID,
        materialsList: currMaterials,
      };
      newSaleDetails.push(newSaleDetailsObject);
      setSaleDetailsTableData([...newSaleDetails]);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getSaleExpandedDetails error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const displaySaleDetails = (saleID: string) => {
    const currSale = salesList.find((sale: any) => sale.saleID === saleID);
    const currSaleDetails = saleDetailsTableData.find((sale: any) => sale.saleID === saleID);
    return (
      <>
        <Row justify="center">
          <Col span={20}>
            <Table dataSource={[...currSaleDetails.materialsList]} columns={saleDetailsColumns} pagination={false} />
          </Col>
        </Row>
        <Row>
          <strong style={{ marginRight: "10px" }}>Sale ID: </strong> {currSaleDetails.saleID}
        </Row>
        {currSale.notes && (
          <>
            <Row style={{ margin: "10px 0" }}>
              <strong>Notes</strong>
            </Row>
            <Row>{currSale.notes}</Row>
          </>
        )}
      </>
    );
  };

  const openDeleteSaleModal = (record: any) => {
    setSaleToDelete(record);
    setIsDeleteModalOpen(true);
  };

  const confirmDeleteSale = async () => {
    setIsDeleteModalOpen(false);
    await deleteSale(saleToDelete.saleID);
    await getSales(currentPage, buyersSelectedOptions, dateRangeFilter);
  };

  const deleteSale = async (saleID: string) => {
    try {
      setLoading(true);
      const res = await deleteSaleService(saleID);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("deleteSale error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const declineDeleteSale = () => {
    setSaleToDelete({});
    setIsDeleteModalOpen(false);
  };

  const editSale = (record: any) => {
    navigate(`/sale/${record.saleID}`);
  };

  const printSalePDF = () => {
    printJS({ printable: encodeURI(printSaleData), type: "pdf", base64: true });
  };

  const confirmFilterMaterials = async () => {
    setIsFilterModalOpen(false);
    await getSales(1, buyersSelectedOptions, dateRangeFilter);
    setIsFilteredData(true);
  };

  const cancelFilterMaterials = () => {
    setIsFilterModalOpen(false);
  };

  const openFilterModal = () => {
    getBuyersFilterOptions();
    setIsFilterModalOpen(true);
  };

  const resetFilters = async () => {
    setBuyersSelectedOptions("");
    setDateRangeFilter([]);
    setDateRangeValue([null, null]);
    await getSales(1, "", []);
    setIsFilterModalOpen(false);
    setIsFilteredData(false);
  };

  const updateBuyerFilter = (value: any) => {
    setBuyersSelectedOptions(value);
  };

  const getSelectedBuyersValue = () => {
    if (buyersSelectedOptions === "") return [];
    return buyersSelectedOptions;
  };

  const updateDateRangeFilter = (dateRange: string[]) => {
    setDateRangeValue([dayjs(dateRange[0], "YYYY-MM-DD"), dayjs(dateRange[1], "YYYY-MM-DD")]);
    setDateRangeFilter(dateRange);
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row justify="start">
              <Col span={12}>
                <h2 className="sales-title">Sales</h2>
              </Col>
              <Col span={12}>
                <Row justify="end">
                  <Button
                    type="default"
                    onClick={() => openFilterModal()}
                    icon={<FilterOutlined />}
                    style={{
                      marginTop: "20px",
                      marginRight: "10px",
                      color: isFilteredData ? "white" : "",
                      backgroundColor: isFilteredData ? "#283555" : "",
                    }}
                  ></Button>
                  <Button
                    type="default"
                    onClick={() => {
                      resetFilters();
                    }}
                    icon={<ReloadOutlined />}
                    style={{ marginTop: "20px" }}
                  >
                    Reload Data
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Table
              className="sales-table"
              dataSource={[...salesList]}
              columns={saleColumns}
              pagination={{
                pageSize: 20,
                total: totalSales,
                showSizeChanger: false,
                onChange: (page) => {
                  setCurrentPage(page);
                  getSales(page, buyersSelectedOptions, dateRangeFilter);
                },
              }}
              expandedRowRender={(record) => displaySaleDetails(record.saleID)}
              expandIcon={({ expanded, onExpand, record }) =>
                expanded ? (
                  <Button type="default" size="small" onClick={(e) => onExpand(record, e)}>
                    Hide Details
                  </Button>
                ) : (
                  <Button
                    type="default"
                    size="small"
                    onClick={async (e) => {
                      await getSaleExpandedDetails(record);
                      onExpand(record, e);
                    }}
                  >
                    Show Details
                  </Button>
                )
              }
            />
          </Col>
        </Row>
        <Copyright />
      </Content>
      <Modal
        title="Delete Sale"
        open={isDeleteModalOpen}
        okText="Confirm Delete"
        okType="danger"
        onOk={confirmDeleteSale}
        onCancel={declineDeleteSale}
      >
        <p>
          Are you sure you want to delete this sale from <strong>{getBuyerDisplayName(saleToDelete.buyerID)}</strong> on{" "}
          <strong>{new Date(saleToDelete.createdTimestamp).toLocaleDateString("en-GB")}</strong>?
        </p>
        <p>This will permanently delete this sale and this action cannot be undone.</p>
      </Modal>
      <Modal
        title="Sale PDF"
        style={{ height: "600px" }}
        open={isPDFModalOpen}
        okText="Print"
        onOk={printSalePDF}
        onCancel={closePDFModal}
      >
        <iframe
          title="printInvoice"
          id="printInvoice"
          src={`data:application/pdf;base64, ${encodeURI(printSaleData)}`}
          height="500px"
          width="100%"
        ></iframe>
      </Modal>
      <Modal
        title="Filter Sales"
        open={isFilterModalOpen}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={cancelFilterMaterials}
      >
        <Row>
          <Col span={24}>
            <Row style={{ marginBottom: "10px" }}>Buyers:</Row>
            <Row style={{ marginBottom: "10px" }}>
              <Select
                showSearch
                mode="multiple"
                allowClear
                style={{ width: "100%" }}
                placeholder="Select buyers"
                value={getSelectedBuyersValue()}
                onChange={updateBuyerFilter}
                options={buyersOptions}
                filterOption={(input: any, option: any) => {
                  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
              />
            </Row>
            <Row style={{ marginBottom: "10px" }}>Date Range:</Row>
            <Row style={{ marginBottom: "10px" }}>
              <RangePicker
                style={{ width: "100%" }}
                // defaultValue={[null, null]}
                // value={[null, null]}
                value={dateRangeValue}
                onChange={(value, dateString: string[]) => {
                  updateDateRangeFilter(dateString);
                }}
                disabledDate={(current) => {
                  let customDate = moment().add(1, "day").format("YYYY-MM-DD");
                  return current && current > moment(customDate, "YYYY-MM-DD");
                }}
              />
            </Row>
            <Row justify="center" style={{ margin: "30px 0" }}>
              <Button onClick={() => resetFilters()} style={{ marginRight: "20px" }}>
                Reset Filters
              </Button>
              <Button type="primary" onClick={() => confirmFilterMaterials()}>
                Filters Sales
              </Button>
            </Row>
          </Col>
        </Row>
      </Modal>
    </Layout>
  );
};

export default SalesPage;
